var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinnowsmback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 198,
    viewBox: "0 0 428 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 198,
    fill: "#F4F1FF",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3286_1393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 428,
    height: 198
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 198,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3286_1393)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 295.323,
    height: 270.544,
    rx: 21.4818,
    transform: "matrix(0.751053 0.660242 -0.757903 0.652367 507.047 -96)",
    fill: "#E6DEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 295.323,
    height: 270.544,
    rx: 21.4818,
    transform: "matrix(0.624784 0.780797 -0.859807 0.510618 -46.3057 -57.5713)",
    fill: "#E6DEFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinnowsmback);
export default __webpack_public_path__ + "static/media/joinnowsmback.57b66ac20c913291e09550615644f159.svg";
export { ForwardRef as ReactComponent };